import React, { Dispatch, SetStateAction } from "react";
import { useStore } from "../../../store/store";

function usePocketSelector(setSliderConfig: Dispatch<SetStateAction<string>>) {
  const addToQuote = useStore((state) => state.addToQuote);

  const sliderP = useStore((state) => state.quote.sliderPocket);

  const handleError = useStore((state) => state.handleError);

  const handleClick = (label: string) => {
    const checked = sliderP === label;

    if (checked) return;

    addToQuote({
      sliderPocket: label,
      exactConfig: "",
    });
    setSliderConfig("");
    handleError("primaryDoorErr", "");
  };

  return {
    handleClick,
    sliderP,
  };
}

export default usePocketSelector;
